module.exports = __webpack_public_path__ + "img/fm.cfc37567.svg";